// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DatePicker CSS start */
.kore-chat-window .datePickerContainer .sdkFooterIcon.calender {
  opacity: 0;
}

.kore-chat-window .sdkFooterIcon.singleCalender .sdkCalender.calenderBtn .calender {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
  margin: -4px;
  display: block;
}

.kore-chat-window .datePickerContainer .close-button {
  cursor: pointer;
  color: #AAAAAA;
  background: none;
  border: none;
  opacity: 1;
  outline: none;
  font-size: 30px;
  float: right;
  line-height: inherit;
  margin-right: 30px;
  margin-top: 5px;
  padding: 0 6px;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.kore-chat-window .datePickerContainer {
  position: relative;
  padding-bottom: 57px;
}

.kore-chat-window .datePickerContainer .headerCalendar {
  height: 56px;
  padding: 20px;
}

.kore-chat-window .datePickerContainer table thead tr:nth-child(2) {
  color: #ccc;
}

.kore-chat-window .datePickerContainer .headerCalendar .choose {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
}

.kore-chat-window .datePickerContainer .headerCalendar .close-button {
  margin: 0;
  padding-top: 8px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 0;
}

.kore-chat-window .datePickerContainer .headerCalendar {
  height: 56px;
  padding: 16px 20px;
  position: relative;
}

.kore-chat-window .datePickerContainer .showDatevalues {
  height: 84px;
  width: 100%;
  background-color: #f2f3f5;
  padding: 15px;
  display: table;
}

.kore-chat-window .datePickerContainer .showDatevalues .showStartdate, .kore-chat-window .datePickerContainer .showDatevalues .showEnddate {
  display: table-cell;
  /* width:50%; */
  text-align: center;
  position: relative;
}

.kore-chat-window .datePickerContainer .showDatevalues .showStartdate .showStartYear {
  font-size: 14px;
  font-weight: 500;
  color: #677180;
  margin-right: 79px;
}

.kore-chat-window .datePickerContainer .showDatevalues .showStartdate .showStartMonth {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
}

.kore-chat-window .datePickerContainer .showDatevalues .showEnddate .showEndYear {
  font-size: 14px;
  font-weight: 500;
  color: #677180;
}

.kore-chat-window .datePickerContainer .showDatevalues .showEnddate .showEndMonth {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
}

.kore-chat-window .datePickerContainer .daterangepicker {
  width: 288px;
  position: relative;
  top: auto;
  left: auto;
  margin: 0 auto;
  border: 0;
  background: transparent;
  /* margin-top: 32px; */
}

.kore-chat-window .datePickerContainer .daterangepicker.drop-up:after {
  display: none;
}

.kore-chat-window .datePickerContainer .daterangepicker.drop-up:before {
  display: none;
}

.kore-chat-window .kore-action-sheet.hide .datePickerContainer .confirmBTN {
  opacity: 0;
}

.kore-chat-window .datePickerContainer .confirmBTN {
  position: absolute;
  z-index: 100;
  height: 54px;
  background: #009dab;
  bottom: 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  opacity: 1;
  line-height: 54px;
  transition: opacity 1.5s ease-in-out;
  -moz-transition: opacity 1.5s ease-in-out;
  -webkit-transition: opacity 1.5s ease-in-out;
}

.darkTheme.kore-chat-window .datePickerContainer .confirmBTN {
  background: #0047CC;
}

.kore-chat-window .datePickerContainer .daterangepicker .drp-calendar.right {
  padding: 8px 8px 0 8px;
}

.kore-chat-window .datePickerContainer .daterangepicker .drp-buttons {
  display: none;
}

.kore-chat-window .datePickerContainer .applyBtn {
  outline: none;
  height: 54px;
  display: none;
}

.kore-chat-window .datePickerContainer .daterangepicker td.active, .kore-chat-window .datePickerContainer .daterangepicker td.active:hover {
  background-color: #e94848;
}

.kore-chat-window .datePickerContainer .daterangepicker .calendar-table th, .kore-chat-window .datePickerContainer .daterangepicker .calendar-table td {
  border-radius: 50%;
  height: 32px;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper {
  font-size: 15px;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper table th {
  font-size: 12px;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.checked.tmp.first-date-selected {
  background-color: #e94848 !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.tmp.checked.last-date-selected {
  background-color: #e94848 !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.checked.first-date-selected {
  background-color: #e94848 !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.checked.last-date-selected {
  background-color: #e94848 !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.real-today {
  background-color: #cdecfa;
  border-radius: 50% !important;
  height: 24px !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper table .day.toMonth.valid {
  border-radius: 50% !important;
  height: 24px !important;
  width: 26px !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper table {
  width: 100% !important;
  /* display: table!important; */
  height: 100% !important;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper {
  text-align: center;
  width: 225px;
  height: 221px;
}

.kore-chat-window .datePickerContainer .date-picker-wrapper table .caption .next, .date-picker-wrapper table .caption .prev {
  border-radius: 50% !important;
  height: 37px !important;
  width: 35px !important;
  font-size: 16px !important;
}

/*DatePicker CSS end*/`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/datePicker/datePicker.scss"],"names":[],"mappings":"AAAC,yBAAA;AACC;EACE,UAAA;AACJ;;AACA;EACI,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAEJ;;AAAC;EACG,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAGJ;;AADC;EACG,aAAA;EACA,mBAAA;EACA,uBAAA;AAIJ;;AAFC;EACG,kBAAA;EACA,oBAAA;AAKJ;;AAHC;EACG,YAAA;EACA,aAAA;AAMJ;;AAJC;EACG,WAAA;AAOJ;;AALC;EACG,eAAA;EACA,iBAAA;EACA,cAAA;AAQJ;;AANC;EACG,SAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AASJ;;AAPC;EACG,YAAA;EACA,kBAAA;EACA,kBAAA;AAUJ;;AARC;EACG,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;AAWJ;;AATC;EACG,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAYJ;;AAVC;EACG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAaJ;;AAXC;EACG,eAAA;EACA,iBAAA;EACA,cAAA;AAcJ;;AAZC;EACG,eAAA;EACA,gBAAA;EACA,cAAA;AAeJ;;AAbC;EACG,eAAA;EACA,iBAAA;EACA,cAAA;AAgBJ;;AAdC;EACG,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;AAiBJ;;AAfC;EACG,aAAA;AAkBJ;;AAhBC;EACG,aAAA;AAmBJ;;AAjBA;EACI,UAAA;AAoBJ;;AAlBC;EACG,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;EACA,yCAAA;EACA,4CAAA;AAqBJ;;AAnBA;EACI,mBAAA;AAsBJ;;AApBC;EACG,sBAAA;AAuBJ;;AArBC;EACG,aAAA;AAwBJ;;AAtBC;EACG,aAAA;EACA,YAAA;EACA,aAAA;AAyBJ;;AAvBC;EACG,yBAAA;AA0BJ;;AAxBC;EACG,kBAAA;EACA,YAAA;AA2BJ;;AAzBA;EACI,eAAA;AA4BJ;;AA1BA;EACI,eAAA;AA6BJ;;AA3BA;EACI,oCAAA;AA8BJ;;AA5BA;EACI,oCAAA;AA+BJ;;AA7BA;EACI,oCAAA;AAgCJ;;AA9BA;EACI,oCAAA;AAiCJ;;AA/BA;EACI,yBAAA;EACA,6BAAA;EACA,uBAAA;AAkCJ;;AAhCA;EACI,6BAAA;EACA,uBAAA;EACA,sBAAA;AAmCJ;;AAjCA;EACI,sBAAA;EACA,8BAAA;EACA,uBAAA;AAoCJ;;AAlCA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;AAqCJ;;AAnCA;EACI,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;AAsCJ;;AApCI,qBAAA","sourcesContent":[" /* DatePicker CSS start */\n  .kore-chat-window .datePickerContainer .sdkFooterIcon.calender{\n    opacity:0;\n}\n.kore-chat-window  .sdkFooterIcon.singleCalender .sdkCalender.calenderBtn .calender{\n    background-image: url('data:image/svg+xml;base64,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');\n    background-size: 100% 100%;\n    width: 21px;\n    height: 21px;\n    margin: -4px;\n    display: block;\n}\n .kore-chat-window .datePickerContainer .close-button{\n    cursor: pointer;\n    color: #AAAAAA;\n    background: none;\n    border: none;\n    opacity: 1;\n    outline: none;\n    font-size: 30px;\n    float:right;\n    line-height: inherit;\n    margin-right: 30px;\n    margin-top:5px;\n    padding: 0 6px;\n}\n .kore-chat-window .datePickerContainer .date-picker-wrapper {\n    display:flex;\n    align-items: center;\n    justify-content: center;\n}\n .kore-chat-window .datePickerContainer{\n    position: relative;\n    padding-bottom: 57px;\n}\n .kore-chat-window .datePickerContainer .headerCalendar{\n    height:56px;\n    padding:20px;\n}\n .kore-chat-window .datePickerContainer table thead tr:nth-child(2) {\n    color: #ccc;\n}\n .kore-chat-window .datePickerContainer .headerCalendar .choose{\n    font-size: 20px;\n    font-weight: bold;\n    color: #000000;\n}\n .kore-chat-window .datePickerContainer .headerCalendar .close-button{\n    margin: 0;\n    padding-top: 8px;\n    cursor: pointer;\n    position: absolute;\n    right: 10px;\n    top: 0;\n}\n .kore-chat-window .datePickerContainer .headerCalendar{\n    height:56px;\n    padding:16px 20px;\n    position: relative;\n}\n .kore-chat-window .datePickerContainer .showDatevalues{\n    height: 84px;\n    width: 100%;\n    background-color: #f2f3f5;\n    padding: 15px;\n    display: table;\n}\n .kore-chat-window .datePickerContainer .showDatevalues .showStartdate,  .kore-chat-window .datePickerContainer .showDatevalues .showEnddate{\n    display: table-cell;\n    /* width:50%; */\n    text-align:center;\n    position: relative;\n}\n .kore-chat-window .datePickerContainer .showDatevalues .showStartdate .showStartYear{\n    font-size: 14px;\n    font-weight: 500;\n    color: #677180;\n    margin-right:79px;\n}\n .kore-chat-window .datePickerContainer .showDatevalues .showStartdate .showStartMonth{\n    font-size: 24px;\n    font-weight: bold;\n    color: #000000;\n}\n .kore-chat-window .datePickerContainer .showDatevalues .showEnddate .showEndYear{\n    font-size: 14px;\n    font-weight: 500;\n    color: #677180;\n}\n .kore-chat-window .datePickerContainer .showDatevalues .showEnddate .showEndMonth{\n    font-size: 24px;\n    font-weight: bold;\n    color: #000000;\n}\n .kore-chat-window .datePickerContainer .daterangepicker{\n    width: 288px;\n    position: relative;\n    top: auto;\n    left: auto;\n    margin: 0 auto;\n    border: 0;\n    background: transparent;\n    /* margin-top: 32px; */\n}\n .kore-chat-window .datePickerContainer .daterangepicker.drop-up:after{\n    display: none;\n}\n .kore-chat-window .datePickerContainer .daterangepicker.drop-up:before{\n    display: none;\n}\n.kore-chat-window .kore-action-sheet.hide .datePickerContainer .confirmBTN{\n    opacity: 0 ;\n}\n .kore-chat-window .datePickerContainer .confirmBTN{\n    position: absolute;\n    z-index: 100;\n    height: 54px;\n    background: #009dab;\n    bottom: 0;\n    width: 100%;\n    text-align: center;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    opacity: 1;\n    line-height: 54px;\n    transition: opacity 1.5s ease-in-out;\n    -moz-transition: opacity 1.5s ease-in-out;\n    -webkit-transition: opacity 1.5s ease-in-out;\n}\n.darkTheme.kore-chat-window .datePickerContainer .confirmBTN{\n    background: #0047CC;\n}\n .kore-chat-window .datePickerContainer .daterangepicker .drp-calendar.right{\n    padding: 8px 8px 0 8px;\n}\n .kore-chat-window .datePickerContainer .daterangepicker .drp-buttons{\n    display: none;\n}\n .kore-chat-window .datePickerContainer .applyBtn{\n    outline: none;\n    height: 54px;\n    display: none;\n}\n .kore-chat-window .datePickerContainer .daterangepicker td.active,  .kore-chat-window .datePickerContainer .daterangepicker td.active:hover{\n    background-color: #e94848;\n}\n .kore-chat-window .datePickerContainer .daterangepicker .calendar-table th,  .kore-chat-window .datePickerContainer .daterangepicker .calendar-table td{\n    border-radius: 50%;\n    height: 32px;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper{\n    font-size: 15px;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper table th{\n    font-size:12px;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.checked.tmp.first-date-selected{\n    background-color: #e94848!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.tmp.checked.last-date-selected{\n    background-color: #e94848!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.checked.first-date-selected{\n    background-color: #e94848!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.checked.last-date-selected{\n    background-color: #e94848!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper .day.toMonth.valid.real-today{\n    background-color: #cdecfa;\n    border-radius: 50%!important;\n    height: 24px!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper table .day.toMonth.valid{\n    border-radius: 50%!important;\n    height: 24px!important;\n    width: 26px!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper table {\n    width: 100%!important;\n    /* display: table!important; */\n    height: 100%!important;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper .month-wrapper{\n    text-align: center;\n    width: 225px;\n    height: 221px;\n}\n.kore-chat-window .datePickerContainer .date-picker-wrapper table .caption .next, .date-picker-wrapper table .caption .prev {\n    border-radius: 50%!important;\n    height: 37px!important;\n    width: 35px!important;\n    font-size: 16px!important;\n}\n    /*DatePicker CSS end*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
